module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/发展空间.3486ab66.png";